<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Property Details</h5>
  <div class="d-flex align-items-center gap-2  ms-auto">
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="openAuditForForm()">
      <fa-icon [icon]="faHistory"></fa-icon>
    </button>
    <button type="button" class="btn-close" aria-label="Close" *ngIf="!generatingLetters" (click)="close()"></button>
  </div>
</div>

<div class="modal-body">


  <div *ngIf="!dataLoaded" class="d-flex justify-content-center py-5">
    <div class="spinner-border text-success" style="width: 3rem; height: 3rem;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <form [formGroup]="propertyDetails" autocomplete="off" *ngIf="dataLoaded">

    <!-- Property & Address -->
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Is the property in the client's name?</label>
        <app-yes-no-form-toggle class="d-block" formControlName="propertyInClientsName" (change)="updateField()"></app-yes-no-form-toggle>

      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Equity Release Postcode</label>
        <div class="input-group">
          <input class="form-control" #equityReleasePostcode maxlength="10"
            formControlName="equityReleasePostcode" (change)="updateField()">
          <app-address-lookup-button [for]="addressLookup1"></app-address-lookup-button>
        </div>
      </div>
    </div>

    <app-address-lookup #addressLookup1 lookupType="postcode" [searchField]="equityReleasePostcode"
      [add1]="propertyDetails.controls['equityReleaseAddressLine1']"
      [add2]="propertyDetails.controls['equityReleaseAddressLine2']"
      [add3]="propertyDetails.controls['equityReleaseAddressLine3']"
      [add4]="propertyDetails.controls['equityReleaseAddressLine4']"
      [add5]="propertyDetails.controls['equityReleaseAddressLine5']"
      [addPc]="propertyDetails.controls['equityReleasePostcode']"
      (change)="updateField()">
    </app-address-lookup>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 1</label>
        <input class="form-control" maxlength="100" formControlName="equityReleaseAddressLine1" (change)="updateField()">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 2</label>
        <input class="form-control" maxlength="100" formControlName="equityReleaseAddressLine2" (change)="updateField()">
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 3</label>
        <input class="form-control" maxlength="100" formControlName="equityReleaseAddressLine3" (change)="updateField()">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 4</label>
        <input class="form-control" maxlength="100" formControlName="equityReleaseAddressLine4" (change)="updateField()">
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 5</label>
        <input class="form-control" maxlength="100" formControlName="equityReleaseAddressLine5" (change)="updateField()">
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-12">
        <label class="form-label fw-semibold">What is/are the reason(s) for obtaining the Equity Release</label>
        <textarea class="form-control" maxlength="250" rows="3"
          formControlName="equityReleaseReason" (change)="updateField()"></textarea>
      </div>
    </div>

    <!-- Property Details -->
    <hr class="my-3">
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Is property Unregistered?</label>
        <app-yes-no-form-toggle class="d-block" formControlName="propertyIsUnregistered" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Title Number</label>
        <input class="form-control" formControlName="titleNumber" (change)="updateField()">
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Do the names on the Mortgage Offer and Title Deeds match?</label>
        <app-yes-no-form-toggle class="d-block" formControlName="namesOnMortgageMatchTitleDeeds" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
    </div>

    <div [hidden]="propertyDetails.controls['namesOnMortgageMatchTitleDeeds'].value != 0">
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Full Legal Name of Client 1</label>
          <input class="form-control" formControlName="clientFullLegalName1" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Full Legal Name of Client 2</label>
          <input class="form-control" formControlName="clientFullLegalName2" (change)="updateField()">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Statement of Truth Regarding Name Discrepancy Required?</label>
          <app-yes-no-form-toggle class="d-block" formControlName="statementOfTruthRegardingNameDiscrepencyRequired" (change)="updateField()"></app-yes-no-form-toggle>
        </div>
      </div>
    </div>

    <!-- Title transfers -->
    <hr class="my-3">
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Transfer of Title into Joint Names</label>
        <app-yes-no-form-toggle class="d-block" formControlName="propertySoleNameTransferIntoJointNames" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
    </div>
    <div [hidden]="propertyDetails.controls['propertySoleNameTransferIntoJointNames'].value != 1">
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Reason</label>
          <input class="form-control" formControlName="propertySoleNameTransferIntoJointNamesReason" (change)="updateField()">
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Removing A Name From Title Required</label>
        <app-yes-no-form-toggle class="d-block" formControlName="propertyJointNameTransferIntoSoleName" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
    </div>
    <div [hidden]="propertyDetails.controls['propertyJointNameTransferIntoSoleName'].value != 1">
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Details/Reason</label>
          <input class="form-control" formControlName="propertyJointNameTransferIntoSoleNameReason" (change)="updateField()">
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Removal of restriction</label>
        <app-yes-no-form-toggle class="d-block" formControlName="removalOfRestriction" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
    </div>
    <div [hidden]="propertyDetails.controls['removalOfRestriction'].value != 1">
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Details/Reason</label>
          <input class="form-control" formControlName="removalOfRestrictionReason" (change)="updateField()">
        </div>
      </div>
    </div>

    <!-- Leasehold -->
    <hr class="my-3">
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Is property Leasehold?</label>
        <app-yes-no-form-toggle class="d-block" formControlName="propertyIsLeasehold" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
    </div>

    <div [hidden]="propertyDetails.controls['propertyIsLeasehold'].value != 1">
      <h6 class="fw-bold mb-3">Landlord Details</h6>
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Landlord Full Name</label>
          <input class="form-control" maxlength="100" formControlName="landlordName" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Landlord Postcode</label>
          <div class="input-group">
            <input class="form-control" #landlordPostcode maxlength="10"
              formControlName="landlordPostcode" (change)="updateField()">
            <app-address-lookup-button [for]="addressLookup4"></app-address-lookup-button>
          </div>
        </div>
      </div>

      <app-address-lookup #addressLookup4 lookupType="postcode" [searchField]="landlordPostcode"
        [add1]="propertyDetails.controls['landlordAddressLine1']"
        [add2]="propertyDetails.controls['landlordAddressLine2']"
        [add3]="propertyDetails.controls['landlordAddressLine3']"
        [add4]="propertyDetails.controls['landlordAddressLine4']"
        [add5]="propertyDetails.controls['landlordAddressLine5']"
        [addPc]="propertyDetails.controls['landlordPostcode']"
        (change)="updateField()">
      </app-address-lookup>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 1</label>
          <input class="form-control" maxlength="100" formControlName="landlordAddressLine1" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 2</label>
          <input class="form-control" maxlength="100" formControlName="landlordAddressLine2" (change)="updateField()">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 3</label>
          <input class="form-control" maxlength="100" formControlName="landlordAddressLine3" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 4</label>
          <input class="form-control" maxlength="100" formControlName="landlordAddressLine4" (change)="updateField()">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 5</label>
          <input class="form-control" maxlength="100" formControlName="landlordAddressLine5" (change)="updateField()">
        </div>
      </div>

      <h6 class="fw-bold mb-3">Management Company</h6>
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Management Company Name</label>
          <input class="form-control" formControlName="managementCompanyName" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Management Company Postcode</label>
          <div class="input-group">
            <input class="form-control" #managementCompanyPostcode maxlength="10"
              formControlName="managementCompanyPostcode" (change)="updateField()">
            <app-address-lookup-button [for]="addressLookup5"></app-address-lookup-button>
          </div>
        </div>
      </div>

      <app-address-lookup #addressLookup5 lookupType="postcode" [searchField]="managementCompanyPostcode"
        [add1]="propertyDetails.controls['managementCompanyAddressLine1']"
        [add2]="propertyDetails.controls['managementCompanyAddressLine2']"
        [add3]="propertyDetails.controls['managementCompanyAddressLine3']"
        [add4]="propertyDetails.controls['managementCompanyAddressLine4']"
        [add5]="propertyDetails.controls['managementCompanyAddressLine5']"
        [addPc]="propertyDetails.controls['managementCompanyPostcode']"
        (change)="updateField()">
      </app-address-lookup>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 1</label>
          <input class="form-control" maxlength="100" formControlName="managementCompanyAddressLine1" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 2</label>
          <input class="form-control" maxlength="100" formControlName="managementCompanyAddressLine2" (change)="updateField()">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 3</label>
          <input class="form-control" maxlength="100" formControlName="managementCompanyAddressLine3" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 4</label>
          <input class="form-control" maxlength="100" formControlName="managementCompanyAddressLine4" (change)="updateField()">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 5</label>
          <input class="form-control" maxlength="100" formControlName="managementCompanyAddressLine5" (change)="updateField()">
        </div>
      </div>
    </div>

    <!-- Solar Panels -->
    <hr class="my-3">
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Solar Panels</label>
        <app-yes-no-form-toggle class="d-block" formControlName="solarPanelsPresent" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
    </div>

    <div [hidden]="propertyDetails.controls['solarPanelsPresent'].value != 1">
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Are the solar panels owned outright?</label>
          <app-yes-no-form-toggle class="d-block" formControlName="solarPanelsOwnedOutright" (change)="updateField()"></app-yes-no-form-toggle>
        </div>
      </div>
      <div [hidden]="propertyDetails.controls['solarPanelsOwnedOutright'].value != 0">
        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Solar Panels Company Name</label>
            <input class="form-control" formControlName="solarPanelsCompany" (change)="updateField()">
          </div>
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Solar Panel Owner Postcode</label>
            <div class="input-group">
              <input class="form-control" #solarPanelsOwnerPostcode maxlength="10"
                formControlName="solarPanelsOwnerPostcode" (change)="updateField()">
              <app-address-lookup-button [for]="addressLookup2"></app-address-lookup-button>
            </div>
          </div>
        </div>

        <app-address-lookup #addressLookup2 lookupType="postcode" [searchField]="solarPanelsOwnerPostcode"
          [add1]="propertyDetails.controls['solarPanelsOwnerAddressLine1']"
          [add2]="propertyDetails.controls['solarPanelsOwnerAddressLine2']"
          [add3]="propertyDetails.controls['solarPanelsOwnerAddressLine3']"
          [add4]="propertyDetails.controls['solarPanelsOwnerAddressLine4']"
          [add5]="propertyDetails.controls['solarPanelsOwnerAddressLine5']"
          [addPc]="propertyDetails.controls['solarPanelsOwnerPostcode']"
          (change)="updateField()">
        </app-address-lookup>

        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Address Line 1</label>
            <input class="form-control" maxlength="100" formControlName="solarPanelsOwnerAddressLine1" (change)="updateField()">
          </div>
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Address Line 2</label>
            <input class="form-control" maxlength="100" formControlName="solarPanelsOwnerAddressLine2" (change)="updateField()">
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Address Line 3</label>
            <input class="form-control" maxlength="100" formControlName="solarPanelsOwnerAddressLine3" (change)="updateField()">
          </div>
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Address Line 4</label>
            <input class="form-control" maxlength="100" formControlName="solarPanelsOwnerAddressLine4" (change)="updateField()">
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Address Line 5</label>
            <input class="form-control" maxlength="100" formControlName="solarPanelsOwnerAddressLine5" (change)="updateField()">
          </div>
        </div>
      </div>
    </div>

    <!-- Septic Tank / Mortgage -->
    <hr class="my-3">
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Septic Tank</label>
        <app-yes-no-form-toggle class="d-block" formControlName="hasSepticTank" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Redeem Mortgage</label>
        <app-yes-no-form-toggle class="d-block" formControlName="redeemMortgage" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
    </div>

    <!-- Lender 1 -->
    <div [hidden]="propertyDetails.controls['redeemMortgage'].value != 1">
      <hr class="my-3">
      <h6 class="fw-bold mb-3">Lender 1</h6>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Lenders Solicitors Shortfall</label>
          <app-yes-no-form-toggle class="d-block" formControlName="lendersSolicitorsShortfall" (change)="updateField()"></app-yes-no-form-toggle>
        </div>
        <div class="col-sm-6" [hidden]="propertyDetails.controls['lendersSolicitorsShortfall'].value != 1">
          <label class="form-label fw-semibold">Shortfall Amount</label>
          <div class="input-group">
            <span class="input-group-text">£</span>
            <input class="form-control" formControlName="lendersSolicitorsShortfallAmount" (change)="updateField()" type="number">
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Current Lender Name</label>
          <input class="form-control" maxlength="100" formControlName="lenderName" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Lender Postcode</label>
          <div class="input-group">
            <input class="form-control" #lenderPostcode maxlength="10"
              formControlName="lenderPostcode" (change)="updateField()">
            <app-address-lookup-button [for]="addressLookup6"></app-address-lookup-button>
          </div>
        </div>
      </div>

      <app-address-lookup #addressLookup6 lookupType="postcode" [searchField]="lenderPostcode"
        [add1]="propertyDetails.controls['lenderAddressLine1']"
        [add2]="propertyDetails.controls['lenderAddressLine2']"
        [add3]="propertyDetails.controls['lenderAddressLine3']"
        [add4]="propertyDetails.controls['lenderAddressLine4']"
        [add5]="propertyDetails.controls['lenderAddressLine5']"
        [addPc]="propertyDetails.controls['lenderPostcode']"
        (change)="updateField()">
      </app-address-lookup>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 1</label>
          <input class="form-control" maxlength="100" formControlName="lenderAddressLine1" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 2</label>
          <input class="form-control" maxlength="100" formControlName="lenderAddressLine2" (change)="updateField()">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 3</label>
          <input class="form-control" maxlength="100" formControlName="lenderAddressLine3" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 4</label>
          <input class="form-control" maxlength="100" formControlName="lenderAddressLine4" (change)="updateField()">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 5</label>
          <input class="form-control" maxlength="100" formControlName="lenderAddressLine5" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Redemption Amount</label>
          <div class="input-group">
            <span class="input-group-text">£</span>
            <input class="form-control" formControlName="redemptionAmount" (change)="updateField()" type="number">
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Adlington Law Redeem Mortgage?</label>
          <app-yes-no-form-toggle class="d-block" formControlName="adlRedeemMortgageLender1" (change)="updateField()"></app-yes-no-form-toggle>
        </div>
      </div>
      <div [hidden]="propertyDetails.controls['adlRedeemMortgageLender1'].value != 1">
        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Lender Sort Code</label>
            <input class="form-control" maxlength="100" formControlName="lender1SortCode" (change)="updateField()">
          </div>
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Lender Account Number</label>
            <input class="form-control" maxlength="100" formControlName="lender1AccountNumber" (change)="updateField()">
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Is there a second lender?</label>
          <app-yes-no-form-toggle class="d-block" formControlName="hasSecondLender" (change)="updateField()"></app-yes-no-form-toggle>
        </div>
      </div>

      <!-- Lender 2 -->
      <div [hidden]="propertyDetails.controls['hasSecondLender'].value != 1">
        <hr class="my-3">
        <h6 class="fw-bold mb-3">Lender 2</h6>

        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Lender 2 Name</label>
            <input class="form-control" maxlength="100" formControlName="lender2Name" (change)="updateField()">
          </div>
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Lender 2 Postcode</label>
            <div class="input-group">
              <input class="form-control" #lender2Postcode maxlength="10"
                formControlName="lender2Postcode" (change)="updateField()">
              <app-address-lookup-button [for]="addressLookup7"></app-address-lookup-button>
            </div>
          </div>
        </div>

        <app-address-lookup #addressLookup7 lookupType="postcode" [searchField]="lender2Postcode"
          [add1]="propertyDetails.controls['lender2AddressLine1']"
          [add2]="propertyDetails.controls['lender2AddressLine2']"
          [add3]="propertyDetails.controls['lender2AddressLine3']"
          [add4]="propertyDetails.controls['lender2AddressLine4']"
          [add5]="propertyDetails.controls['lender2AddressLine5']"
          [addPc]="propertyDetails.controls['lender2Postcode']"
          (change)="updateField()">
        </app-address-lookup>

        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Address Line 1</label>
            <input class="form-control" maxlength="100" formControlName="lender2AddressLine1" (change)="updateField()">
          </div>
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Address Line 2</label>
            <input class="form-control" maxlength="100" formControlName="lender2AddressLine2" (change)="updateField()">
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Address Line 3</label>
            <input class="form-control" maxlength="100" formControlName="lender2AddressLine3" (change)="updateField()">
          </div>
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Address Line 4</label>
            <input class="form-control" maxlength="100" formControlName="lender2AddressLine4" (change)="updateField()">
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Address Line 5</label>
            <input class="form-control" maxlength="100" formControlName="lender2AddressLine5" (change)="updateField()">
          </div>
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Lender 2 Redemption Amount</label>
            <div class="input-group">
              <span class="input-group-text">£</span>
              <input class="form-control" formControlName="redemptionAmount2" (change)="updateField()" type="number">
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Adlington Law Redeem Mortgage?</label>
            <app-yes-no-form-toggle class="d-block" formControlName="adlRedeemMortgageLender2" (change)="updateField()"></app-yes-no-form-toggle>
          </div>
        </div>
        <div [hidden]="propertyDetails.controls['adlRedeemMortgageLender2'].value != 1">
          <div class="row mb-3">
            <div class="col-sm-6">
              <label class="form-label fw-semibold">Lender 2 Sort Code</label>
              <input class="form-control" maxlength="100" formControlName="lender2SortCode" (change)="updateField()">
            </div>
            <div class="col-sm-6">
              <label class="form-label fw-semibold">Lender 2 Account Number</label>
              <input class="form-control" maxlength="100" formControlName="lender2AccountNumber" (change)="updateField()">
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Is there a third lender?</label>
            <app-yes-no-form-toggle class="d-block" formControlName="hasThirdLender" (change)="updateField()"></app-yes-no-form-toggle>
          </div>
        </div>

        <!-- Lender 3 -->
        <div [hidden]="propertyDetails.controls['hasThirdLender'].value != 1">
          <hr class="my-3">
          <h6 class="fw-bold mb-3">Lender 3</h6>

          <div class="row mb-3">
            <div class="col-sm-6">
              <label class="form-label fw-semibold">Lender 3 Name</label>
              <input class="form-control" maxlength="100" formControlName="lender3Name" (change)="updateField()">
            </div>
            <div class="col-sm-6">
              <label class="form-label fw-semibold">Lender 3 Postcode</label>
              <div class="input-group">
                <input class="form-control" #lender3Postcode maxlength="10"
                  formControlName="lender3Postcode" (change)="updateField()">
                <app-address-lookup-button [for]="addressLookup8"></app-address-lookup-button>
              </div>
            </div>
          </div>

          <app-address-lookup #addressLookup8 lookupType="postcode" [searchField]="lender3Postcode"
            [add1]="propertyDetails.controls['lender3AddressLine1']"
            [add2]="propertyDetails.controls['lender3AddressLine2']"
            [add3]="propertyDetails.controls['lender3AddressLine3']"
            [add4]="propertyDetails.controls['lender3AddressLine4']"
            [add5]="propertyDetails.controls['lender3AddressLine5']"
            [addPc]="propertyDetails.controls['lender3Postcode']"
            (change)="updateField()">
          </app-address-lookup>

          <div class="row mb-3">
            <div class="col-sm-6">
              <label class="form-label fw-semibold">Address Line 1</label>
              <input class="form-control" maxlength="100" formControlName="lender3AddressLine1" (change)="updateField()">
            </div>
            <div class="col-sm-6">
              <label class="form-label fw-semibold">Address Line 2</label>
              <input class="form-control" maxlength="100" formControlName="lender3AddressLine2" (change)="updateField()">
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-sm-6">
              <label class="form-label fw-semibold">Address Line 3</label>
              <input class="form-control" maxlength="100" formControlName="lender3AddressLine3" (change)="updateField()">
            </div>
            <div class="col-sm-6">
              <label class="form-label fw-semibold">Address Line 4</label>
              <input class="form-control" maxlength="100" formControlName="lender3AddressLine4" (change)="updateField()">
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-sm-6">
              <label class="form-label fw-semibold">Address Line 5</label>
              <input class="form-control" maxlength="100" formControlName="lender3AddressLine5" (change)="updateField()">
            </div>
            <div class="col-sm-6">
              <label class="form-label fw-semibold">Lender 3 Redemption Amount</label>
              <div class="input-group">
                <span class="input-group-text">£</span>
                <input class="form-control" formControlName="redemptionAmount3" (change)="updateField()" type="number">
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-6">
              <label class="form-label fw-semibold">Adlington Law Redeem Mortgage?</label>
              <app-yes-no-form-toggle class="d-block" formControlName="adlRedeemMortgageLender3" (change)="updateField()"></app-yes-no-form-toggle>
            </div>
          </div>
          <div [hidden]="propertyDetails.controls['adlRedeemMortgageLender3'].value != 1">
            <div class="row mb-3">
              <div class="col-sm-6">
                <label class="form-label fw-semibold">Lender 3 Sort Code</label>
                <input class="form-control" maxlength="100" formControlName="lender3SortCode" (change)="updateField()">
              </div>
              <div class="col-sm-6">
                <label class="form-label fw-semibold">Lender 3 Account Number</label>
                <input class="form-control" maxlength="100" formControlName="lender3AccountNumber" (change)="updateField()">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Additional questions -->
    <hr class="my-3">
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Is the client going through divorce or separation proceedings?</label>
        <app-yes-no-form-toggle class="d-block" formControlName="clientGoingThroughDivorceSeparationProceedings" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Is the client under an LPA?</label>
        <app-yes-no-form-toggle class="d-block" formControlName="clientUnderLPA" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Is there a Trust situation?</label>
        <app-yes-no-form-toggle class="d-block" formControlName="isThereATrustSituation" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Has the client ever been declared bankrupt?</label>
        <app-yes-no-form-toggle class="d-block" formControlName="clientEverBeenDeclaredBankrupt" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
    </div>

  </form>
</div>

<div class="modal-footer">
  <button *ngIf="!generatingLetters" type="button" class="btn btn-success" (click)="createLetters()">
    Create Admin Letters
  </button>
  <button *ngIf="generatingLetters" type="button" class="btn btn-success" disabled>
    <span class="spinner-border spinner-border-sm" role="status"></span>
    Generating...
  </button>
</div>